module.exports = __webpack_public_path__ + "images/cb3f4805aea6542266d5469bbd0e6e8e-illu_hub.svg";